import template from './dynamicLinkListPage.html';
import controller from './dynamicLinkListPage.controller';
import './dynamicLinkListPage.scss';

let dynamicLinkListPageComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default dynamicLinkListPageComponent;
